export default "__VITE_ASSET__BxnyLPcq__"